// extracted by mini-css-extract-plugin
export default {"NewNetworkContainer":"kCTpR2Cw"};